export default __webpack_public_path__ + "static/media/Captura_Pantalla.2a77987f.png";